import React, { useState, useEffect } from "react";
// import "./CheckWarranty.scss";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../../../../services/api/API";
import CustomTable from "../../../../customComponents/CustomTable";
// import ROUTES_NAVIGATION from "../../../../routes/routes";
import viewIcon from "../../../../../Assets/icons/ClaimIcon.svg";
import ListLogisticsFilters from "../../../Logistics/LogisticsFilter";
import DownloadSVG from "../../../../../Assets/icons/DownloadIconMIS.svg";
import download from "../../../../../Assets/icons/download.svg";
import * as base64 from "base-64";
import CustomMisTable from "../../../../customComponents/customMisReportTable";
import { showErrorAlert } from "../../../../customComponents/CustomSweetAlert/errorsweetalert";
import { FiDownload } from "react-icons/fi";
import SearchInput from "../../../../customComponents/CustomSearch/SearchInput";
// import DetailsTable from "../../Admin/OrderManagement/CustomOrderTable/CustomOrderTable";

const DealerVehicleReport = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [variantOptions, setVariantOptions] = useState([]);
  const [modelOptions, setModelOptions] = useState([]);
  const [filterList, setFilterList] = useState();
  const [totalRecords, setTotalRecords] = useState(0);
  const [filterFormData, setFilterFormData] = useState({});
  const [filters, setFilters] = useState({});
  const [vinNoData, setVinNoData] = useState([]);
  // const [isSearchPerformed, setIsSearchPerformed] = useState(false);
  const [validationErrors, setValidationErrors] = useState({});

  const [colorOptions, setColorOptions] = useState([]);
  const [dealerOption, setDealerOptions] = useState([]);

  const navigate = useNavigate();
  const token = localStorage.getItem("authToken");
  const dealerId = localStorage.getItem("dealerId");
  localStorage.removeItem("JobCardComplainData");

  useEffect(() => {
    fetchJobCardList();
  }, [filterList]);

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
    fetchJobCardList(newPage);
  };

  const formatDate = (date) => {
    if (!date) return null;
    const d = new Date(date);
    // Format to YYYY-MM-DD without timezone influence
    return new Date(d.getTime() - d.getTimezoneOffset() * 60000)
      .toISOString()
      .slice(0, 10);
  };

  const formatDateToYYYYMMDD = (date) => {
    if (!date) return null;
    const d = new Date(date);
    const day = String(d.getDate()).padStart(2, "0");
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const year = d.getFullYear();
    return `${year}-${month}-${day}`;
  };

  const fetchJobCardList = async (page = 0, pageSize = 10) => {
    const allfilteredData = filters;
    const formattedStartDate = formatDateToYYYYMMDD(allfilteredData?.fromDate);
    const formattedEndDate = formatDateToYYYYMMDD(allfilteredData?.toDate);

    const payload = {
      dealerId: allfilteredData.dealerId || null,
      // fromDate: allfilteredData?.fromDate ? allfilteredData?.fromDate : null,
      // toDate: allfilteredData?.fromDate ? allfilteredData?.toDate : null,

      startDate: formattedStartDate,
      endDate: formattedEndDate,
      //   modelId: allfilteredData?.modelId ? allfilteredData?.modelId : null,
      //   variantId: allfilteredData?.variantId ? allfilteredData?.variantId : null,
      //   colorId: allfilteredData?.color ? allfilteredData?.color : null,
      vinNum: null,
      product_name: searchTerm,
      orderBy: "postockinsr_id desc",
      page,
      pageSize,
    };
    try {
      // setTableLoader(true)
      const response = await axiosInstance.post(
        "/mis/vehicle-details-report",
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );
      // setTableLoader(false)
      const formattedData = response?.data?.data?.data.map((item, index) => ({
        ...item,
        item_name: item.item_name || "--",
        model_name: item.model_name || "--",
        variant_name: item.variant_name || "--",
        postockinsr_id: item.postockinsr_id || "--",
        po_number: item?.po_number || "--",
        vin_no: item?.vin_no || "--",
        serial_no: item?.serial_no || "--",
        motor_no: item?.motor_no || "--",
        po_date: item?.po_date || "--",
        variant_name: item?.variant_name || "--",
        status: item?.status || "--",
        dealer_name: item?.dealer_name || "--",
        controller_no: item?.controller_no || "--",
        dispatch_date: item?.dispatch_date || "--",
      }));
      const totalRecordsData = response?.data?.data?.totalRecords;
      setTotalRecords(totalRecordsData);
      setTotalPages(Math.ceil(response?.data?.data?.totalRecords / pageSize));
      setVinNoData(formattedData);
    } catch (error) {
      console.error("Error fetching business partners:", error);
      // setIsSearchPerformed(false);
    }
  };

  const onClickNavigetion = (item) => {
    return (
      <div onClick={() => handleEdit(item)}>
        <span style={{ color: "green" }}> {item?.job_card_no}</span>
      </div>
    );
  };

  const handleEdit = (rowData) => {
    navigate("add-job-card", {
      state: { jobCardDataDetails: JSON.parse(JSON.stringify(rowData)) },
    });
  };

  const handleViewButton = (rowData) => {
    navigate("job-card-details", {
      state: { data: JSON.parse(JSON.stringify(rowData)) },
    });
  };

  // Table headers
  const Job_Card_TABLE_HEADERS = [
    "Dealer Name",
    "Item Type",
    // "PO Number",
    "PO Detail Number",
    "Model Name",
    "Color Name",

    "Product Name",
    "Vin Number",
    "Motor Number",
    "Controller Number",
    "Serial Number",
    "Dispatch Date",
  ];

  // Key mapping for CustomTable component
  const BUSINESS_PARTNER_KEY_MAPPING = {
    "Dealer Name": "dealer_name",
    "Item Type": "itemtype",
    "PO Detail Number":"podetail_number",
    "Customer Name": "full_name",
    "PO Number": "po_number",
    "Vin Number": "vin_no",
    "Motor Number": "motor_no",
    "Controller Number": "controller_no",
    "Serial Number": "serial_no",
    // "Serial Number": "serial_no",
    "PO Date": "po_date",
    "Email Id": "email_id",
    "Contact Number": "mobile_no",
    "Product Name": "product_name",
    "Model Name": "model_name",
    "Color Name": "color_name",
    "Dispatch Date": "dispatch_date",
    // "Days":"remaining_days",
    //  "Warranty From":"warrantyFrom",
    // "Warranty To":"warrantyTo",
    Action: [
      {
        type: "downloadRiderDetails",
        icon: download,
        label: "downloadRiderDetails",
      },
    ],
  };

  const onclickFilter = (row) => {
    setFilterList(row);
  };

  useEffect(() => {
    fetchJobCardList();
  }, [filters]);

  // const clearFilter = () => {
  //   setFilterFormData({});
  //   setFilters({});
  //   fetchJobCardList();
  // };
  useEffect(() => {
    if (searchTerm === "") {
      fetchJobCardList();
    }
  }, [searchTerm]);

  // const handleSearch = () => {
  //   setFilters({
  //     vinNumber: filterFormData.searchTerm || null
  //   });
  //   // setIsSearchPerformed(true);
  //   fetchJobCardList();
  // };
  const clearSearchAndFetch = () => {
    setSearchTerm("");
  };

  const handleSearchInputChange = (event) => {
    setSearchTerm(event.target.value);
  };

  const handleClear = () => {
    setFilterFormData({});
  };
  const handleClaim = () => {
    console.log("clicked");
    // navigate(ROUTES_NAVIGATION.ADDJOBCARD)
  };

  useEffect(() => {
    fetchDealers();
  }, []);

  const fetchDealers = async () => {
    try {
      const response = await axiosInstance.post("/dealer/ddldealer", {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      const data = response?.data?.data?.data;

      const dealerOptions = data.map((dealer) => ({
        value: dealer.dealer_id,
        label: dealer.dealer_name,
      }));

      setDealerOptions(dealerOptions);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchModelOptions();
  }, []);

  const fetchModelOptions = async () => {
    try {
      const payload = {
        orderBy: "model_id desc",
        page: 0,
        pageSize: 100,
      };

      const response = await axiosInstance.post("/model/ddlmodel", payload, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      const options = response.data.data.data.map((model) => ({
        label: model.NAME,
        value: model.ID,
      }));
      console.log(options, "responseVal");

      setModelOptions(options);
    } catch (error) {
      console.error("Error fetching model options:", error);
    }
  };

  useEffect(() => {
    // const colorId = formData.color
    const modelId = filterFormData.modelId;
    const dealerIdVal = filterFormData.dealerId;

    const colorIdVal = filterFormData.colorId;

    if (modelId && dealerIdVal && colorIdVal) {
      fetchVariantOptions(modelId, dealerIdVal, colorIdVal);
    }
  }, [filterFormData.modelId, filterFormData.dealerId, filterFormData.colorId]);

  const fetchVariantOptions = async (modelId, dealerIdVal, colorIdVal) => {
    try {
      const token = localStorage.getItem("authToken");
      const response = await axiosInstance.post(
        "/variant/ddlvariant",
        {
          color_id: colorIdVal,
          model_id: modelId,
          dealer_id: dealerIdVal,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );
      const options = response.data.data.data?.map((variant) => ({
        label: variant.NAME,
        value: variant.ID,
      }));
      setVariantOptions(options);
    } catch (error) {
      console.error("Error fetching variant options:", error);
    }
  };

  const PhysicalStockTakingInputs = [
    {
      name: "dealerId",
      label: "Dealer ",
      placeholder: "Select Dealer",
      type: "dropdown",
      options: dealerOption,
      // required: true,
      gridClass: "col-lg-3",
    },
    // {
    //   name: "is_order_accepted",
    //   label: "SearchType",
    //   placeholder: "Select City",
    //   type: "dropdown",
    //   options: [
    //     { label: "Order Pending", value: 0 },
    //     { label: "Modified", value: 8 },
    //     { label: "Order Approved", value: 1 },
    //     { label: "Order Partially Approved", value: 6 },
    //     { label: "Order Partially Delivered", value: 5 },
    //     { label: "Order Hold", value: 4 },
    //     { label: "All", value: -1 },
    //     { label: "Dispatched", value: 3 },
    //     { label: "Order Rejected", value: 2 },
    //     { label: "Order Cancelled", value: 7 },
    //     // { label: "Modified Status", value: 8 },
    //     { label: "Re-Submitted", value: 9 },
    //   ],
    //   // required: true,
    //   gridClass: "col-lg-3",
    // },
    {
      name: "fromDate",
      label: "From Date",
      type: "date",
      maxDate: new Date(),
      // required: true,
      gridClass: "col-lg-3",
    },
    {
      name: "toDate",
      label: "To Date",
      type: "date",
      maxDate: new Date(),
      // required: true,
      gridClass: "col-lg-3",
    },
  ];

  const handleSearch = () => {
    // Update the filters state with the current form data
    // setFilters({
    //   is_order_accepted:filterFormData.is_order_accepted || 0,
    //   fromDate: filterFormData.fromDate || null,
    //   toDate: filterFormData.toDate || null,
    //   dealerId: filterFormData.dealerId || null,

    // });
    const updatedFilters = {
      // is_order_accepted: filterFormData.is_order_accepted || 0,
      is_order_accepted:
        filterFormData.is_order_accepted !== undefined &&
        filterFormData.is_order_accepted !== null
          ? filterFormData.is_order_accepted
          : -1, // default All
      fromDate: filterFormData.fromDate || null,
      toDate: filterFormData.toDate || null,
      dealerId: filterFormData.dealerId || null,
    };

    setFilters(updatedFilters);
  };

  const clearFilter = () => {
    setFilterFormData({});
    setFilters({});
    fetchJobCardList();
  };

  const downloadExcel = async () => {
    const allfilteredData = filters;
     const formattedStartDate = formatDateToYYYYMMDD(allfilteredData?.fromDate);
    const formattedEndDate = formatDateToYYYYMMDD(allfilteredData?.toDate);
    const payload = {
       dealerId: allfilteredData.dealerId || null,
      // fromDate: allfilteredData?.fromDate ? allfilteredData?.fromDate : null,
      // toDate: allfilteredData?.fromDate ? allfilteredData?.toDate : null,

      startDate: formattedStartDate || allfilteredData?.fromDate,
      endDate: formattedEndDate || allfilteredData?.toDate,
      //   modelId: allfilteredData?.modelId ? allfilteredData?.modelId : null,
      //   variantId: allfilteredData?.variantId ? allfilteredData?.variantId : null,
      //   colorId: allfilteredData?.color ? allfilteredData?.color : null,
      vinNum: null,
      product_name: searchTerm,
      orderBy: "postockinsr_id desc",
      page: 0,
      pageSize: 10,
    };

    try {
      const response = await axiosInstance.post(
        "/mis/vehicle-details-report-excel",
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          responseType: "blob", // Important: Ensures the response is treated as a file
        },
      );

      // Create a Blob from the response
      const blob = new Blob([response.data], { type: "text/csv" });

      // Create a download link
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = "Customer Sales Report.csv"; // Set the file name
      link.style.display = "none";

      // Append the link to the body and trigger the download
      document.body.appendChild(link);
      link.click();

      // Clean up the link element
      document.body.removeChild(link);
    } catch (error) {
      console.error("Error downloading Excel file:", error);

      const errorMessage = error?.response?.statusText;
      console.log(errorMessage, "errorMessage");

      const alertText =
        errorMessage === "Not Found"
          ? "Record not found"
          : errorMessage || "Something went wrong";

      showErrorAlert({
        title: "Warning",
        text: alertText,
        callback: () => {
          console.log("Error alert confirmed");
        },
      });
    }
  };

  useEffect(() => {
    const modelId = filterFormData.modelId;

    if (modelId) {
      fetchColorOptions(modelId);
    }
  }, [filterFormData.modelId]);

  const fetchColorOptions = async (modelId) => {
    try {
      const payload = {
        page: 0,
        pageSize: 100,
        model_id: modelId,
      };

      const response = await axiosInstance.post("/color/ddlcolor", payload, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      const options = response.data.data.data.map((color) => ({
        label: color.NAME,
        value: color.ID,
      }));

      setColorOptions(options);
    } catch (error) {
      console.error("Error fetching model options:", error);
    }
  };

  const DownLoadPdf = async (row) => {
    try {
      const response = await axiosInstance.get(
        `/mis/dealer-stock-report-download/${row?.po_id}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );

      const fileData = response?.data?.data?.[0];
      const fileUrl = fileData?.imageURL;

      if (!fileUrl) {
        throw new Error("File URL not found");
      }

      // 🔽 Trigger download
      const link = document.createElement("a");
      link.href = fileUrl;
      link.setAttribute("download", "dealer-stock-report.pdf"); // optional filename
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.log(error, "error");

      const errorMessage = error.response?.data?.data;

      showErrorAlert({
        title: "",
        text:
          errorMessage || "An error occurred while processing your request.",
        callback: () => {
          console.log("Error alert confirmed");
        },
      });
    }
  };

  return (
    <div>
      <div className="OnboardManagamentContainer ">
        <div
          style={{ width: "100%" }}
          className="OnboardManagamentbuttonContainer  col-md-3 mt-2 mb-2"
        >
          <div
            style={{
              lineHeight: "1px",
              display: "flex",
              flexDirection: "column",
              paddingTop: "30px",
            }}
          >
            <div>
              <p className="ServiceBreadcrumbs">Home / Report / MIS Report </p>
            </div>
            <div>
              <h5
                style={{ fontWeight: "600" }}
                className="checkWarrantyHeading"
              >
                Stock Details Report
              </h5>
            </div>
          </div>

          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: "25px",
            }}
          >
            <ListLogisticsFilters
              formConfig={PhysicalStockTakingInputs}
              formData={filterFormData}
              setFormData={setFilterFormData}
              validationErrors={validationErrors}
              setValidationErrors={setValidationErrors}
              handleSearch={handleSearch}
              handleClear={clearFilter}
            />
            {/* <img
              onClick={downloadExcel}
              src={DownloadSVG}
              alt="downloadSvg"
              style={{ paddingTop: "33px", cursor: "pointer" }}
            /> */}

            <div
              onClick={downloadExcel}
              className="flte-btnnn"
              style={{
                borderRadius: "38px",
                cursor: "pointer",
                fontSize: "15px",
              }}
            >
              Stock Details Report Download
              <span>
                <FiDownload
                  className="downloadexcel-misreportsales"
                  style={{ cursor: "pointer" }}
                  size={22}
                />
              </span>
            </div>
            <div></div>
          </div>
        </div>
        <div className=" col-md-8 mt-2 mb-2 gap-2 totalvaluescontainer">
          <div className="listSideBorder" />
        </div>
      </div>
      <div className="tableWrapper">
        <div className="filterView">
          <div>
            <SearchInput
              placeholder="Search Vin No./Serial No."
              onSearch={fetchJobCardList}
              searchTerm={searchTerm}
              setSearchTerm={setSearchTerm}
            />
          </div>
        </div>

        <div style={{ paddingTop: "20px" }}>
          <CustomTable
            data={vinNoData}
            headers={Job_Card_TABLE_HEADERS}
            keyMapping={BUSINESS_PARTNER_KEY_MAPPING}
            onEdit={handleEdit}
            handleViewButton={handleViewButton}
            itemsPerPage={10}
            totalPages={totalPages}
            onPageChange={handlePageChange}
            totalRecords={totalRecords}
            handleClaim={handleClaim}
            // isADDcomplainTable="true"
            currentPage={currentPage}
            pdfDownLoad={DownLoadPdf}
          />
          {/* )} */}
        </div>
      </div>
    </div>
  );
};

export default DealerVehicleReport;
